import React from 'react';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import { offer_networkId } from '../../../utils/query-helpers';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('note.find', {
    where: {
      eager: {
        $where: {
          offerId: {
            $null: false
          },
          ...offer_networkId(network),
          ...params
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
